// src/components/home/FlashingTech.js
import React from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import flashing from "../../media/images/flashing_tape.png";
import voronka from "../../media/images/voronka-removebg-preview.png";
import barbakan from "../../media/images/barbakan-removebg-preview.png";

const TechWrap = styled.section`
    background: linear-gradient(135deg, #fafafa 0%, #f1f1f1 100%);
    padding: 80px 20px;
    position: relative;
`;

const TechContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
`;

const SlideContent = styled.div`
    padding: 0 80px; /* move content inward so arrows don’t overlap */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
`;

const TechText = styled.div`
    flex: 1 1 500px;

    h2 {
        font-size: clamp(1.8rem, 3vw, 2.5rem);
        color: #3d6c4d;
        margin-bottom: 20px;
    }

    p {
        font-size: 1.1rem;
        line-height: 1.8;
        color: #333;
        margin-bottom: 30px;
    }
`;

const TechList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;

    li {
        font-size: 1rem;
        color: #444;
        position: relative;
        padding-left: 32px;
        margin-bottom: 14px;

        &:before {
            content: "✓";
            position: absolute;
            left: 0;
            color: #c58e50;
            font-weight: bold;
        }
    }
`;

const TechImage = styled.img`
    width: 90%;
    max-width: 400px;
    border-radius: 12px;
    transform: rotateY(-8deg) rotateX(3deg);
`;

const ArrowButton = styled.div`
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #3d6c4d, #2f523a);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  cursor: pointer;
  z-index: 1000;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-50%) scale(1.15);
    box-shadow: 0 6px 20px rgba(0,0,0,0.4);
    background: linear-gradient(135deg, #3d6c4d, #6ba57a);
  }

  svg {
    width: 18px;
    height: 18px;
    fill: #fff;
  }
`;

const StyledSwiper = styled(Swiper)`
  overflow: hidden; /* ensures next slide is not visible */
  position: relative;

  .swiper-pagination-bullet {
    background: #3d6c4d;
    opacity: 0.7;
  }

  .swiper-pagination-bullet-active {
    background: #c58e50;
    opacity: 1;
  }
`;

export default function FlashingTech() {
    return (
        <TechWrap>
            <StyledSwiper
                modules={[Navigation, Pagination]}
                spaceBetween={50}
                slidesPerView={1}
                navigation={{
                    prevEl: ".custom-prev",
                    nextEl: ".custom-next",
                }}
                pagination={{ clickable: true }}
            >
                {/* Slide 1 */}
                <SwiperSlide>
                    <SlideContent>
                        <TechText>
                            <h2>Облоцовъчна лента</h2>
                            <p>
                                EPDM системите използват студено свързване, което
                                осигурява дълготрайна и надеждна връзка без нагряване или пламък.
                                Това е безопасно, чисто и изключително ефективно решение за
                                модерни покриви.
                            </p>
                            <TechList>
                                <li>Химическа молекулярна връзка за максимална плътност</li>
                                <li>Безопасно за обекта – без огън и нагряване</li>
                                <li>Лесно и бързо приложение на ленти и мембрани</li>
                            </TechList>
                        </TechText>
                        <TechImage src={flashing} alt="EPDM свързваща лента" />
                    </SlideContent>
                </SwiperSlide>

                {/* Slide 2 */}
                <SwiperSlide>
                    <SlideContent>
                        <TechText>
                            <h2>Воронка с EPDM фланец</h2>
                            <p>
                                Вграден покривен водосток с гъвкав EPDM самозалепващ фланец, подходящ за вертикален или хоризонтален монтаж.
                                Осигурява сигурна и водоустойчива връзка веднага след полагане, без нагряване или пламък.
                            </p>
                            <TechList>
                                <li>Гъвкав EPDM фланец с високоефективно сцепление</li>
                                <li>Може да се огъва до 90° по ръбовете за лесен монтаж</li>
                                <li>Подходящ за различни диаметри и видове покриви</li>
                                <li>Осигурява надеждно отвеждане на вода и защита на покрива</li>
                            </TechList>
                        </TechText>
                        <TechImage src={voronka} alt="Flex Gully Systemflansch"/>
                    </SlideContent>
                </SwiperSlide>

                {/* Slide 3 */}
                <SwiperSlide>
                    <SlideContent>
                        <TechText>
                            <h2>EPDM Барбакан</h2>
                            <p>
                                Специално проектиран за хоризонтално оттичане на вода от плоски покриви през парапет.
                                Изходът може да се монтира както вертикално, така и хоризонтално, осигурявайки гъвкавост при инсталацията.
                            </p>
                            <TechList>
                                <li>Изработен от висококачествен EPDM за дълготрайна устойчивост</li>
                                <li>Фланецът улеснява инсталацията с наклон</li>
                                <li>Включва PVC опорна рамка за стабилност по време на монтажа</li>
                            </TechList>
                        </TechText>
                        <TechImage src={barbakan} alt="EPDM Seitenauslauf 60 x 100 mm"/>
                    </SlideContent>
                </SwiperSlide>

                {/* Custom navigation buttons */}
                <ArrowButton className="custom-prev" style={{ left: "3px" }}>
                    <svg viewBox="0 0 24 24">
                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                    </svg>
                </ArrowButton>
                <ArrowButton className="custom-next" style={{ right: "3px" }}>
                    <svg viewBox="0 0 24 24">
                        <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>
                    </svg>
                </ArrowButton>

            </StyledSwiper>
        </TechWrap>
    );
}
